import API from "..";
import ShippingAddress from "../WorkRequest/ShippingAddress";
import { checkAPIResponse } from "../helpers";

export default class ExternalLaboratory {
  /**
   * @param {String} laboratoryName
   * @param {String} labCode
   * @param {int} shippingAddressID
   * @param {bool} isActive 
   * @param {String} labContactEmailAddress 
   * @param {String} onSiteContactEmailAddress
   * @param {String} notes 
   * @param {String} createdByEmail 
   * @param {Datetime} createdDate 
   * @param {String} lastModifiedByEmail
   * @param {Datetime} lastModifiedDate
   * @param {ShippingAddress} shippingAddress
   */

  constructor({
    laboratoryName,
    labCode,
    shippingAddressID,
    isActive,
    labContactEmailAddress,
    onSiteContactEmailAddress,
    notes,
    createdByEmail,
    createdDate,
    lastModifiedByEmail,
    lastModifiedDate,
    shippingAddress }) {
    this.laboratoryName = laboratoryName;
    this.labCode = labCode;
    this.shippingAddressID = shippingAddressID;
    this.isActive = isActive;
    this.labContactEmailAddress = labContactEmailAddress;
    this.onSiteContactEmailAddress = onSiteContactEmailAddress;
    this.notes = notes;
    this.createdByEmail = createdByEmail;
    this.createdDate = createdDate;
    this.lastModifiedByEmail = lastModifiedByEmail;
    this.lastModifiedDate = lastModifiedDate;
    this.shippingAddress = shippingAddress ? new ShippingAddress(shippingAddress) : null;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/externalLaboratory?includeInactive=true`);
    return data.result.map((d) => new ExternalLaboratory(d));
  }

  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/externalLaboratory?includeInactive=false`);
    return data.result.map((d) => new ExternalLaboratory(d));
  }

  static async add(info) {
    const api = await API();
    const response = await api.post(`/externalLaboratory`, info);
    checkAPIResponse(response);
    return new ExternalLaboratory(response.data.result);
  }

  static async update(laboratoryName, info) {
    const api = await API();
    const response = await api.put(`/externalLaboratory`, info, {
      params: { laboratoryName },
    });
    checkAPIResponse(response);
    return new ExternalLaboratory(response.data.result);
  }
}